import React, { useEffect } from 'react';
import { Spin } from 'antd';
import './style.css';

const index = () => {

  return (<div id="clearDom">
    <div className="order_dom">
      <Spin></Spin>
    </div>
  </div>)
}

export default index;